export default {
	'changeAnswer': 'Change answer',
	'variables': 'Variables',
	'variablesList': 'Variable List',
	'autoAnswers': 'Auto answers',
	'deletionReminders': 'Deletion Reminders',
	'emailSubject': 'Email subject',
	'emailSubjectPlaceholder': 'Anfrage [@order_id@]',
	'download': 'Download files',
	'addTicket': 'Add Order',
	'addTask': 'Add Task',
	'from': 'From',
	'to': 'To',
	'reset': 'Reset',
	'searchByNameAndClient': 'Search by name and client',
	'searchByCid': 'Search by CID',
	'save': 'Save',
	'cancel': 'Cancel',
	'chooseDate': 'Choose date',
	'description': 'Description',
	'taskView': 'task description',
	'date': 'Date',
	'ticket': 'Order',
	'setByAdmin': 'Important!',
	'delete': 'Delete',
	'done': 'Done',
	'notDone': 'Not done',
	'completedSuccessfully': 'Successfully completed',
	'addedSuccessfully': 'Successfully added',
	'changedSuccessfully': 'Successfully changed',
	'deletedSuccessfully': 'Successfully deleted',
	'name': 'Name',
	'subject': 'Subject',
	'type': 'Type',
	'causedBy': 'Issue type',
	'failCausedBy': 'Fail caused by',
	'managerFail': 'Manager fail',
	'badQuality': ' Bad quality',
	'deadlineIssue': 'Deadline issue',
	'dispute': 'Dispute',
	'aiOrPlagiarism': 'AI or Plagiarism',
	'clientProblematic': 'Client problematic',
	'clientMistake': 'Client mistake',
	'clientOff': 'Client off',
	'clientWithdrawal': 'Client Withdrawal',
	'invoicingError': 'Invoicing Error',
	'reasonFailed': 'Reasons for failed',
	'failComment': 'Order fail comment',
	'closureComment': 'Order closure comment',
	'pagesCount': 'Pages',
	'milestonesCount': 'milestones',
	'priceEuro': 'Price, €',
	'dueDate': 'Deadline',
	'manager': 'Manager',
	'comment': 'Comment',
	'client': 'Client',
	'level': 'Level',
	'author': 'Author',
	'agency': 'Agency',
	'kiNeuroauthor': 'KI Neuroauthor',
	'task': 'Tasks',
	'new': 'New',
	'newPpg': 'New Ppg',
	'clientNotAnswer': 'Unanswered',
	'processing': 'Processing',
	'waitingPayment': 'Awaiting Payment',
	'waitingAuthor': 'In search of an artist',
	"inProgress": "In process",
	'waitingApprove': 'Confirmed',
	'completed': 'Completed',
	'failedWithPayout': "Failed (with payout)",
	'failed': 'Failed',
	'basket': 'Basket',
	'promocode': "Promo Code",
	'confirmUnblockingOrder': 'Confirm order recovery',
	'orderRestoredSuccessfully': 'Order successfully restored',
	'confirmBlockingUser': 'Confirm blocking customer',
	'confirmUnblockingUser': 'Confirm unblocking user',
	'ban_clients': 'Blocked clients',
	'user_banned_successfully': 'Client successfully blocked',
	'user_unbanned_successfully': 'Client successfully unblocked',
	'confirmBlocking': 'Confirm blocking',
	"confirmUnblocking": "Confirm unblocking",
	'createOrder': 'Create order',
	'clientsEmail': 'Client E-Mail',
	'site': 'Site',
	'subjectArea': 'Subject',
	'workType': 'Type of work',
	'isKi': 'KI only',
	'qualityLevel': 'Quality level',
	'pagesAmount': 'Number of pages',
	'workLanguage': 'Language of execution',
	'language': 'Language',
	'loadFile': 'Load file',
	'create': 'Create',
	'orderWasCreatedSuccessfully': 'Order was successfully created',
	'createdBy': 'Created by',
	'order': 'Order',
	'closeOrder': 'Close order',
	'currentOrderStatus': 'Current Order Status',
	'orderClosureStatus': 'Order closure status',
	'verySatisfied': 'Very Satisfied',
	'satisfied': 'Satisfied',
	'dissatisfied': 'Dissatisfied',
	'neutralNoFeedback': 'Neutral - No Feedback',
	'neutralMinorCorrections': 'Neutral - Minor Corrections',
	'neutralCompromiseSolution': 'Neutral - Compromise Solution',
	'neutralResolvedIssue': 'Neutral - Resolved Issue',
	'price': 'Price',
	'refuseWork': 'Refuse Order',
	'message': 'Message',
	'writeMessage': 'Write Message',
	'invitesWasSent': 'invitations sent',
	'youMarkedOrderAs': 'You marked the order as',
	'confirmAction': 'Confirm action',
	'agree': 'Start order',
	'youWantToMarkOrderAs': 'You are going to mark the order as',
	'totalWorks': 'Total orders',
	'currentWorks': 'Current Orders',
	'currentVsLimit': 'Current / Limit',
	'favorites': 'Favorites',
	'invite': 'Invite',
	'performersRequests': 'Performers Requests',
	'select': 'Select',
	'selectTags': 'Select Tags',
	'selectReason': 'Select Reason',
	'yourRequestsWasSentSuccessfully': 'Your invitations have been successfully sent',
	'youHaveAssignedAuthorToThisProject': 'You have assigned an author to this order',
	'thanksWeReceivedYourRequest': 'Thank you, we have received your request',
	'managerWillConfirmItSoon': 'A manager will confirm it shortly',
	'pleaseWait': 'Please wait',
	'paymentDetails': 'Payment details',
	'addPaymentDetails': 'Add payment details',
	'paymentType': 'Payment type',
	'selectPaymentType': 'Select payment type',
	'details': 'Details',
	'client_file': 'Client file',
	'stage': 'Stage',
	'priceForClient': 'Price for customer',
	'priceForNative': 'Price for Native',
	'priceForJuniorAndMiddle': 'Price for Middle',
	'priceForSenior': 'Price for Senior',
	'pagesAmountShort': 'Number of pages',
	'loadPhoto': 'Load photo',
	'recommendedPaymentSum': 'Recommended payment sum',
	'totalPaymentSum': 'Total payment sum',
	'lowerThanRecommendedSum': 'Amount less than recommended',
	'addStage': 'Add stage',
	'sendForApproval': 'Send for Approval',
	'edit': 'Edit',
	'approve': 'Approve',
	'firstlyAddWorkTypeToOrder': 'Select a job type',
	'youConfirmedPaymentSuccessfully': 'You have successfully confirmed payment',
	'dataWasSentToClientForApproval': 'Files have been sent to the client',
	'dataWasSentForApproval': 'The document has been sent for approval',
	'youMarkedStageAs': 'You marked the stage as',
	'stageWasMovedToStatus': 'Change order status:',
	'payRewardToAuthor': "Pay the author's royalties",
	'authorsReward': 'Amount of royalties',
	'failureType': 'Failure category',
	'pay': 'Pay',
	'doCancel': 'Cancel',
	'indicateFailureReason': 'Indicate failure reason',
	'informationAboutOrder': 'Order information',
	'workTheme': 'Work theme',
	'workLongTerm': 'Work long term',
	'additionalSale': 'Additional Sale',
	'clientComment': 'Client comment',
	'recommendedSumShort': 'Recommended sum short',
	'add': 'Add',
	'attachedFiles': 'AttachedFiles | AttachedFiles | AttachedFiles | AttachedFiles',
	'paymentMethod': 'Payment method',
	'filesFromAuthor': 'Files from Author',
	'filesFromClient': 'Files from Client',
	'send': 'Send',
	'firstEmailReply': "Send first reply",
	'sendAutomatically': 'Send automatically',
	'filesWasSentToClient': 'Files have been sent to the client',
	'notAllowedFileType': 'This file type is not allowed for upload.',
	'refuse': 'Refuse',
	'youWantToCompleteOrder': 'You are about to complete the order',
	'thisActionIsIrreversible': 'This action is irreversible',
	'completeOrder': 'Complete the order',
	'orderIsCompletedSuccessfully': 'The order has been successfully completed',
	'onlyAdminCanRemovePromocode': 'Only admin can remove promocode',
	'writeToManager': 'Write to manager',
	'discuss': 'Under discussion',
	'creationDate': 'Creation date',
	'calculatedSum': 'Calculated sum',
	'includingVAT': 'Including VAT',
	'assign': 'assign',
	'chooseManager': 'Choose manager',
	'passwordRecovery': 'Password recovery',
	'enterYourEmailAndWeWillSendYouNewPassword': 'Enter your email and we will send you a new password',
	'recoverPassword': 'Recover password',
	'toLoginPage': 'To login page',
	'newPasswordIsGeneratedAndSentToMail': 'New password sent to email',
	'registration': 'Registration',
	'fillFormBelowToCreateNewAccount': 'Fill out the form below to create a new account',
	'youAreAlreadyLoggedIn': "You're already logged in!",
	'entrance': 'Login',
	'welcomeBack': 'Welcome back',
	'pleaseLoginToYourAccount': 'Please log in to your account',
	'password': 'Password',
	'repeatPassword': 'Repeat password',
	'newPassword': 'New password',
	'yes': 'Yes',
	'no': 'No',
	'confirmDeletion': 'Confirm deletion',
	'doYouWantToDelete': 'You are about to delete',
	'registrationLinkCreation': 'Create a registration link',
	'linkToRegistrationForm': 'Link to registration form',
	'generate': 'Generate',
	'close': 'Close',
	'nickname': 'Nickname',
	'emailForPayment': 'SEPA/SWIFT IBAN',
	'iban': 'IBAN',
	'swift': 'SWIFT',
	'street': 'Street',
	'phone': 'Phone',
	'sex': 'Gender',
	'country': 'Country',
	'city': 'City',
	'houseNumber': 'House Number',
	'apartmentNumber': 'Apartment Number',
	'postalCode': 'Postal Code',
	'accountEmail': 'Account email',
	'cryptoUSDT': 'Crypto USDT',
	'birthDate': 'Date of Birth',
	'bankEU': 'Bank account EU',
	'bankNonEU': 'Bank account Non-EU',
	'mellow': 'Mellow',
	'wise': 'TransferWise',
	'mellowAccEmail': 'Mellow account email',
	'payoneerAccEmail': 'Payoneer account email',
	'payoneer': 'Payoneer',
	'recipientName': "Recipient's name",
	'recipientCountry': "Recipient's country",
	'recipientAddress': "Recipient's address",
	'crypto': 'Сrypto USDT',
	'cryptoField': 'Crypto wallet address',
	'TRC20': 'TRC20',
	'ERC20': 'ERC20',
	'USDT': 'USDT',
	'surname': 'Last name',
	'fullName': 'Full Name',
	'holderFullName': "Account holder's full name",
	"profile": "Profile",
	'subjects': 'Subjects',
	'undesirableSubjects': 'Undesirable subjects',
	'aboutYourself': 'AboutYourself',
	'dataIsSaved': 'Data saved',
	'totalOrdersCount': 'Total number of orders',
	'success': 'Success',
	'personName': 'Name',
	'changeWorkType': 'Change work type',
	'shortRussian': 'Russian',
	'shortGerman': 'German',
	'totalTicketsAmount': 'Total number of orders',
	'activatedTickets': 'Active orders',
	'income': 'Income',
	'totalIncome': 'Total income',
	'clientEditing': 'Client editing',
	'additionalEmail': 'Additional email',
	'activatedOrder': 'Active orders',
	'changingManagerRequest': 'Change manager request',
	'newManager': 'New manager',
	'confirm': 'Confirm',
	'decline': 'Reject',
	'firstlySelectManager': 'Must specify manager first',
	'changingManagerRequestIsSent': 'A request to change manager has been sent',
	'requestWasDeclined': 'Request has been canceled',
	'actions': 'Actions',
	'removalOrderReason': 'Reason for removing the order',
	'orderAddedToBasket': 'Order moved to cart',
	'totalOrders': 'Total Orders',
	'paidOrder': 'Paid',
	'hangingOrders': 'Hanging orders',
	'sitesPreferences': 'Settings for sites',
	'managerEditing': 'Manager editing',
	'managerCreating': 'Creating a manager',
	'sitesSettings': 'Site settings',
	'basicPrices': 'Basic prices',
	'workTypesVisibility': 'Visibility of work types',
	'invoicesData': 'Invoice data',
	'changesIsSavedSuccessfully': 'Changes saved successfully',
	'siteWasCreatedSuccessfully': 'Site was successfully created',
	'managerFee': 'Manager Fee',
	'deleteLogo': 'Delete logo',
	'firmInfo': 'Firm Information',
	'termsAndConditions': 'Terms and Conditions',
	'part': 'part',
	'changeLogo': 'Change logo',
	'mainColor': 'MainColor',
	'additionalColor': 'Additional Color',
	'showForJunior': 'Show for Junior',
	'showForMiddle': 'Show for Middle',
	'showForSenior': 'Show for Senior',
	'showForNative': 'Show for Native',
	'general': 'General',
	'bySites': 'BySites',
	'openDiscuss': 'Open Discuss',
	'opened': 'Open',
	'number': 'Number',
	'discussTheme': 'Theme',
	'status': 'Status',
	'order_limit': 'Order limit',
	'lastAnswer': 'LastAnswer',
	'answerReceived': 'Response received',
	'waitingToAnswer': 'Awaiting reply',
	'closed': 'Closed',
	'isClosed': 'Closed',
	'openNewDiscuss': 'Open New Discuss',
	'discussText': 'DiscussText',
	'doYouWantToCloseDiscuss': 'You are about to close the discussion',
	'closeDiscuss': 'Close the appeal',
	'aDiscuss': 'Discussion',
	'discussStatus': 'Discussion Status',
	'write': 'Write',
	'techSupport': 'Tech Support',
	'pendingConsideration': 'Pending',
	'paidOut': 'Paid out',
	'rejected': 'Rejected',
	'paidRequest': 'Withdrawal',
	'writeHowMuchYouWantToWithdraw': 'Specify how much you want to withdraw',
	'pleaseFillPaymentDetails': 'Withdraw operation is forbidden, fill payment details first.',
	'rejectPayment': 'Reject payment',
	'paymentRejectingReason': 'Reason for rejecting payment',
	'currentBalance': 'Current Balance',
	'withdraw': 'Withdraw',
	'rejectSuccessfully': 'Successfully rejected',
	'idTransaction': 'Transaction ID',
	'sum': 'Amount',
	'paymentSystem': 'Payment System',
	'paymentRequests': 'Payment Requests',
	'paymentsHistory': 'Payment history',
	'accrualHistory': 'Accrual history',
	'ordersHistory': "Orders history",
	'user': 'User',
	'rejectedPayments': 'Rejected Payments',
	'addWorkType': 'AddWork Type',
	'responseText': 'Response Text',
	'addAnswer': 'add answer',
	'ago': 'ago',
	'month(1)': 'month',
	'month(2-5)': 'months',
	'month(6-0)': 'months',
	'more': 'more',
	'lessThanMonth': 'Less Than Month',
	'markAllAsRead': 'Mark all as read',
	'orders': 'Orders',
	'techSupportShort': 'Tech Support',
	'exchangePageName': 'Exchange',
	'tickets': 'Orders',
	'statistics': 'Statistics',
	'finances': 'Finance',
	'tasks': 'Tasks',
	'clients': 'Clients',
	'managers': 'Managers',
	'logs': "Managers' logs",
	'authors': 'Authors',
	"sites": "Sites",
	"akadeule" : "Akad Eule",
	"wirSchreiben" : "WirSchreiben",
	"ghostwriter" : "Ghostwriter",
	"studienLab" : "StudienLab",
	"akadHilfe24" : "AkadHilfe24",
	"otherBrand" : "Other Brand",
	"ki": "KI",
	"siteBrand" : "Brand",
	'workTypes': 'Work Types',
	'templateAnswers': 'Template answers',
	'scheduledTasks': 'Tasks',
	'all': 'All',
	'clean': 'Clean',
	'reason': 'Reason',
	'deleted': 'In trash',
	'notDone(many)': 'Actual',
	'sort': 'Sort',
	'tasksCalendar': 'Task Calendar',
	'languages': 'Languages',
	'accessDenied': 'Access Denied',
	"addPhoto": "Add photo",
	'male': 'Male',
	'female': 'Female',
	'searchByOrderName': 'Search by name',
	'searchByPhone': 'Search by phone',
	'addOrder': 'Add Order',
	'addTag': "Add Tag",
	'doYouWantToRejectOrder': "You're going to cancel the order",
	'yourPersonalManager': 'Your Personal Manager',
	'requestAnotherManager': 'Request another manager',
	'writeReason': 'Describe reason',
	'profileEditing': 'Edit profile',
	'changePhoto': 'ChangePhoto',
	'deletePhoto': 'Delete photo',
	'chatWithYourManager(p1)': 'Chatting with your',
	'chatWithYourManager(p2)': "Manager",
	'chatByOrder': 'Chat by order',
	'search': 'Search',
	'copywriter': 'Author',
	'admin': 'Administrator',
	'successNotification': 'Successful',
	'dangerNotification': 'Warning',
	"uploadWarning": "Successfully uploaded {success} out of {total} files.",
	'errorNotification': 'Error',
	'fieldFilledIncorrect': 'Field filled incorrectly',
	'rescheduleReason': 'Reschedule reason',
	'authorRequest': "Author's request",
	'noAuthorResponse': 'No author response',
	'clientRequest': "Client's request",
	'noClientResponse': 'No client response',
	'orderUnderQaReview': 'Order Under QA Review',
	'delayedCustomerPayment': 'Delayed customer payment',
	'revisionsDelayedDeadline': 'Revisions delayed deadline',
	'shortTaskDeadline': 'Short task deadline',
	'changeStageAuthor': "Change stage author",

	// --------------- V2
  'newMessagesCountDisplay': 'New',
	'logout': 'Logout',
	'english': 'English',
	'russian': 'Russian',
	"german": "German",
	'french': "French",
	'locale': "Locale",
	"sunday": "Sunday",
	"monday": "Monday",
	"tuesday": "Tuesday",
	"wednesday": "Wednesday",
	"thursday": "Thursday",
	"friday": "Friday",
	"saturday": "saturday",
	"sundayShort": "all",
	"mondayShort": "Mon",
	"tuesdayShort": "wt",
	"wednesdayShort": "Wed",
	"thursdayShort": "cht",
	"fridayShort": "pt",
	"saturdayShort": "Sat",
	"january": "January",
	"february": "February",
	"march": "March",
	"april": "April",
	"may": "May",
	"june": "June",
	"july": "july",
	"august": "August",
	"september": "September",
	"october": "October",
	"november": "November",
	"december": "December",
	"januaryGenitive": "January",
	"februaryGenitive": "February",
	"marchGenitive": "March",
	"aprilGenitive": "april",
	"mayGenitive": "May",
	"juneGenitive": "June",
	"julyGenitive": "July",
	"augustGenitive": "August",
	"septemberGenitive": "September",
	"octoberGenitive": "october",
	"novemberGenitive": "November",
	"decemberGenitive": "December",
	"unread": "Unread",
	"read": "Read",
	"history" : "History",
	// --------------- end V2

	// --------------- V3
	"newtonsLaw": "Newton's Law",
	"topic": "Topic",
	"finished": "Completed",
	"stages": "Stages",
	"confirmUploading": "Confirm Download",
	"fileDeletedSuccessfully": "File successfully deleted",
	"fileDeletionError": "An error occurred while trying to delete a file",
	"isConfirmingStage": "Stage is now on manager confirmation",
	"changeTemplateAnswer": "Change TemplateAnswer",
	"pages": "{n} pages | {n} page | {n} page | {n} page | {n} pages",
	"doYouWantToDeleteAuthorFromOrder": "You are going to remove the author from the order.",
	"doYouWantToDeleteFile": "You are about to delete a file",
	"youDeletedAuthorFromOrder": "You have removed the author from this order.",
	"noDataAvailable": "No data found",
	"secondsAgo": "0 Seconds ago | {n} Seconds ago | {n} Seconds ago | {n} Seconds ago | {n} Seconds ago",
	"minutesAgo": "0 Minutes ago | {n} Minutes ago | {n} Minutes ago | {n} Minutes ago",
	"hoursAgo": "0 Hours ago | {n} Hours ago | {n} Hours ago | {n} Hours ago",
	"daysAgo": "0 Days ago | {n} Day ago | {n} Days ago | {n} Days ago",
	"yearsAgo": "0 Years ago | {n} Year ago | {n} Years ago | {n} Years ago",
	"justNow": "Now",

	"followUP" : "Follow-up",

	"statusRequest1": "Statusanfrage 1",
	"statusRequest2": "Statusanfrage 2",
	"statusRequest3": "Statusanfrage 3",
	"statusRequest4": "Statusanfrage 4",
	"statusRequest5": "Statusanfrage 5",

	"waitingForPayment1": "Warten auf Zahlung 1",
	"waitingForPayment2": "Warten auf Zahlung 2",
	"waitingForPayment3": "Warten auf Zahlung 3",

	"offerFollowUp": "Ofer",
	"deleteFollowUp" : "Löschen",
	// --------------- end V3

	"workTypeName": "Packages",
	"packagePaid": "Package purchase date",
	"packageExpiry": "Package expiry date",


	// --------------- V4
  "writeMessageToAuthor": "Write to Author",
  "writeMessageToClient": "Write toClient",
  "chatWithAuthor": "Chat with Author",
  "chatOpenTooLong": "The chat has been open for too long. Please log in again to continue the conversation.",

  "createSuborder": "Suborder",
  "mainOrder": "Main order",
	// --------------- end V4
	'support': 'Support',
	'sales': "Sales",
	"payments": "Payments",
	"exchange": {
    'name': 'Theme',
    'area': 'Subject',
    'type': 'Type',
    'page': 'Pages',
    'stage': 'Stages',
    'price': 'Price',
    'price_junior_middle': 'Price for Junior/Middle',
    'price_senior': 'Price for Senior',
    'deadline': 'Deadline',
    'accept': 'Accept',
    'decline': 'Reject',
    'confirmAction': 'Confirm Action',
    'confirmActionText': 'You are about to accept this order.',
    'confirmActionTextFalse': 'You are about to decline the invitation for this order.',
    'confirmPopup': 'Confirm',
    'order': 'Order',
    'countStages': 'Number of Stages',
	'workTheme': 'Work theme',
    'subject': 'Subject',
    'typeWork': 'Type of Work',
    'levelQuality': 'LevelQuality',
    'countPages': 'Number of pages',
    'attachFile': 'Attachments',
    'langWork': 'Language of execution',
    'comment': 'Comment',
    'getToWork': 'Get started!',
    'filter': 'Filter',
    'searchToName': 'Search by name',
    'level': 'Level',
    'off': 'From',
    'to': 'To',
    'reset': 'Reset',
    'inviteDecline': 'Invitation declined',
    'inviteDeclineText': 'You have successfully declined the invitation. You will still be able to submit a request to fulfill this order if you change your mind.',
    'inviteAccept': 'Invitation accepted',
    'inviteAcceptText': 'Thank you, you may proceed.',
    'requestSend': 'Application has been sent',
    'requestSendText': 'Thank you, we have received your application. The manager will confirm it soon. Please wait.',
    'success': 'Successful',
    'successText': 'Successfully completed',
    'deleteText': 'Successfully deleted',
    'acceptText': 'Successfully added',
	},
	"stats": {
    "junior": 'Economy',
    'middle': 'Business',
    "senior": "Academic",
    "income": 'Income',
    'total': 'Net',
    "totalIncome": "Income",
    "privateIncome": 'Personal Income',
    'sitesCount': 'Sites',
    'paidOrdersCount': 'Paid',
    'waitingOrdersCount': 'Hanging',
    "graphIncome": "Personal Income",
    'graphOrders': 'Orders',
    'graphIncomeGlobal': 'Income',
    "graphOrdersPaid": "Hanging Orders",
    "completeOrder": "Fulfilled",
    "successOrder": 'Success',
    "today": 'Today',
    "yesterday": 'Yesterday',
    'currentWeek': 'CurrentWeek',
    'prevWeek': 'Last week',
    "current_month": 'Current month',
    "last_month": 'Last month',
    "last_three_month": 'Three months',
    "last_six_month": 'Half a year',
    "last_year": 'Year',
    "all_time": 'All time',
    'active': 'Active orders',
    'clientsCount': 'Customers',
    'authorsCount': 'Authors',
    'managersCount': 'Managers',
    'salesManagers': 'Sales Managers',
    'salesSites': 'Sales by Site',
    "totalPaymentsForPeriod": 'Total payments per period',
    'totalPaidForPeriod': 'Total paid per period',
    'incomeTotal': 'Gross',
    'incomeClean': 'Net',
    'ordersCount': 'Total orders',
    'graphUsers': 'New Users',
    'graphQualityLevels': 'Orders by quality levels',
    'graphSubjects': 'Orders by subject',
    'graphAdminIncome': 'Profit Ratio',
    'newPaidTickets': 'Orders',
    'completedTickets': 'Statuses of completed orders',
    "conversion": 'Conversion',
    "date": 'Date',
    "manager": 'Manager',
    'clients': 'Customers',
    'authors': 'Authors',
    'mangers': 'Managers',
    "graph_new": "New orders",
    "paid": "Paid orders",
    "completed": 'Completed',
    "failed": 'Failed',
    'countOfRefunds': 'Number of refunds',
    'sumOfRefunds': 'Sum of Returns',
    "penalties": "Penalties",
    "manualCredits": "Manual credits",
    "fails": "Fails",
    "countOfFails": "Count of fails",
    "leeds": "Leeds",
	},
	"changePrice": "Change price",
  "indicateThePrice": "Indicate the price",
	"priceChangedSuccessfully": "Price successfully changed",
  "searchById": "Search by ID",
	"wrongField": "Wrong Field",
	"forThisDay": "To date",
	"№": "№",
	"plagiatPercentage": "Plagiarism percentage",
	"reportFile": "ReportFile",
	"markAsRead": "Mark As Read",
	"archive": "Archive",
	"chat": "Chat",
	"info": "Info",
	"milestoneId": "Milestone ID",
	"milestonePosition": "Milestone",
  "comments": "Comments",
  "view": "View",
  "changeBalance": "ChangeBalance",
  "balanceIn": "Add",
  "balanceOut": "Debit",
  "paymentAmount": "Payment amount",
  "workIsPaidCanContinue": "Customer has paid this part, you can write.",
  "workIsNotPaidWait": "The customer has NOT paid for this part yet, please wait for a manager's message to start working on it.",
  "assignAnOrder": "Assign order",
	"assignGeneratorManager": "Assign PPG Manager",
	"generatorManager": "PPG Manager",


	"externalEmails": "Additional emails",
	"priceForMiddle": "Price for middle",
	"unreadMessages": "Unread messages",
  "markAsProblem": "Mark as Problem",
  "problemAuthor": "Problem Author",
  "authorMarkedAsProblem": "Author marked as problematic",
  "otherProfiles": "Other profiles",
  "refund": "Refund",
  "refunds": "Refunds",
  "refundReasons": "Reasons for refunds",
	"indicateRefundReason": "Indicate reason for refund",
  "penalty": "Penalty",
	"needPenalty": "Need a penalty?",
	"lateness": "Lateness",
	"authorsRequest": "Author's request",
	"unableToCompleteOrder": "Unable to complete order",
	"other" : "Other",
	"instructionsNotFollowed" : "Instructions not followed",
	"plagiarism" : "Plagiarism",
	"AI" : "AI",
	"reassignReason": "Reasons for reassignment",
	"qualityIssue": "Quality issue",
	"reassign": "Reassign",
	"reassignAuthor": "Reassign Author",
	"requiredField": "This is a required field",
	"chooseAuthorReassignReason": "Please indicate the reason why you are reassigning this author",
	"shareDetailsAboutReassign": "Please share more details on why the author is being reassigned",
	"warning": "Warning",
  "penaltySum": "Penalty sum",
  "penaltiesSum": "Penalty amount",
  "sumOfRefunds": "Sum of refunds",
  "choosePenaltyReason": "Specify penalty reason",
  "penaltyAmount": "Penalty amount",
  "penaltyReason": "Penalty Reason",
  "penaltyCount": "Number of penalties",
  "pricePerPage": "Price per page",
  "operation": {
    "title": "Operation",
    "in": "Added",
    "out": "Debited"
  },
  "amountOfIncome": "Amount of income",
  "confirmPaymentManually": "Confirm payment manually",
	"accountant": "Accountant",
  "marginality": "Marginality",
  "marginalityConfirmationText": "Marginality is below the minimum required (author's fee is too high). Are you sure the information is correct?",
  "failsReasons": "Reasons for failures.",
  "marginalityWarning": 'CAUTION: MARGINALITY LOWER THAN NORMAL',
  "orderPriceIncorrectWarning": 'CAUTION: PRICE DISAGREES FROM RECOMMENDED BY MORE THAN 10%',
  "confirmPayment": "Confirm payment",
  "totalActions": "Total actions",
  "wordsCount": "Words count",
  "downloadActs": "Download acts",
  "answerTime": "Answer time",
  "replyTypes": "Reply types",
  "minutesShort": "min.",
  "averageAnswerTimeBy": "Average response time, minutes",
  "averageAnswerTime": "Average response time",
  "noAnswer": "No Answer",
  "authorDidNotChooseMainBankCard": "The author has not selected a main card.",
  "youDidNotChooseMainBankCard": "You did not select a primary card",
  "bankCards": "Bank cards",
  "updateCardsList": "Update cards list",
  "toUpdateCardsListYouMustToWait": "To update cards list you must to wait {n} min.",
  'bankCardsFromSolarStaff': 'Bank cards (retrieved from solar-staff)',
	"updatedSuccessfully": "Successfully updated",
	'stagesTotal': "Stages (total)",
  'check': "Check",
  'fileWillBeCheckedAsSoonAsPossible': "File will be checked as soon as possible",
  "group": 'Group',
  'activeOrdersCount': 'Number of active orders',
  'activeOrders': 'Active Orders',
  "orderId": "Order Number",
  'doNotNotifyClient': 'Do not notify client',
  'searchByName': 'Search by name',
  'emptyList': 'List is empty',
  'totalLeadsByPeriod': 'Total orders per period',
  'totalPayedLeadsByPeriod': 'Total paid orders per period',
  "ignoreSpam": "Ignore Spam",
  "conversionPercent": "Conversion Percentage",
  "maxValue": "Maximum value {n}",
  "fieldRequired": "Field required",
  "minLength": "minimum {n}",
  "maxLength": "maximum {n}",
  "utm": {
	"matchtype":"Match type",
	"gclid":"GCLID",
	"wbraid":"WBRAID",
	"gbraid":"GBRAID",
	"fbclid":"FBCLID",
    "utm_medium":"UTM medium",
    "utm_source":"UTM source",
    "utm_term":"UTM Term",
    "utm_campaign":"UTM Campaign",
    "adgroupid":"Ad group ID",
    "targetid":"Target ID",
    "orderSource": "Ticket source",
    "source": "Source",
    "search_word": "Search word",
    "cid": "CID",
    "geo": "GEO",
    "medium": "Medium",
	"browser_agent": "Browser agent",
	"sid": "SID",
	"sct": "SCT"
  },
  "orderHistory": {
    "entityType": "Type",
    "initiatorRole": "Initiator role",
    "initiatorName": "Initiator name",
    "field": "Field",
    "old": "Old value",
    "new": "New value",
    "createdAt": "Created at"
  },
	"skipReminders": "Do not send reminders",
	"contactTimeReminders": "Send contact time reminders",
	"doNotDeleteOrderAfterEmails": 'Do not delete the order after emails',
	"sendDeletionReminders": 'Send reminders after deletion',
	"uploadAuthorFilesInstruction": "Please send your work to the chat with the manager",
	"downloadAuthorsFiles": "Download authors files",
	"qualityAssurance": "Quality assurance",
	"problemsWithQuality": "Quality problems",
	"quality": "Quality",
	"sendpulse": {
		"resubscriptionRequested": "Re-subscription request have been sent. Client not receiving a message from CRM until they accept it. If it takes too much time or there is something urgent, use the website mail directly to contact client. Client unsubscribed from : {unsubscribe_date}",
		"unsubscribed": "The client has unsubscribed from emails sent via sendpulse. They are not receiving a message from CRM at this time. In case of urgent need, it is necessary to use the website mail directly. If the customer sends us a message, a re-subscription request will be sent automatically. Client unsubscribed from : {unsubscribe_date}",
	},
	"authorDeadline": "Author deadline",
	"deadlineCalculatedApproximately": "Until the customer has paid for next milestones the deadline is calculated approximately. The final deadline for the milestone will be displayed once the customer approves the previous milestone and pays for the next.",
	"offerSent": "Offer sent",
	"guidesHint": "This is a page dedicated to collecting all out policies in one place. Here you'll find everything you need to successfully work on our platform.",
	"policiesAndGuides": "Policies & guides",
	"howToUse": "Policies and guides",
	"contactViaWhatsapp": "Contact via Whatsapp",
	"contactPhone": "Phone",
	'contactTime': "Contact time",
	"changeStatus": "Change status",
	"forceChangeStatus": "Change ticket status without any additional notifications or related logics. Note!!! it can affect ticket workflow",
	"ticketStatus": "Ticket status",
	"activeMilestone": "Active stage",
	"activeMilestoneStatus": "Active stage status",
	"globalSettings": "System settings",
	"systemSettings": {
		"create_order_new_email": "Create order from first email from new client"
	},
	"systemSettingsGroup": {
		"main": "General"
	},
	"authorHint" : "Please upload the file in .doc or .docx format (unless requested otherwise by the customer)<br>Make sure that your file does not contain any metadata about you. Here's a guide how to <a href='https://criticalfault.com/blog/how-to-remove-metadata-from-word-documents/' target='_blank'>remove metadata</a> from your document",
	// "Ticket": "Тикет",
	// "Assign": "Назначить",
	// "Delete": "Удалить",
	// "Choose a manager": "Выберите менеджера",
	// "entrance": "Вход",
	// "Welcome back! Please login to your account": "С возвращением! Пожалуйста, войдите в свой аккаунт",
	// "Password": "Пароль",
	// "Password recovery": "Востановление пароля",
	// "registration": "Регистрация",
	// "Attempt to login": "Попытка входа в систему",
	// "You are already signed in": "Вы уже вошли в систему",
	// "Fill out the form below to create a new account": "Заполните форму ниже, чтобы создать новую учутную запись",
	// "Enter your email and we will send you a new password": "Введите свой email и мы отправим вам новый пароль",
	// "Go to login page": "На страницу входа",
	// "Successfully": "Успешно",
	// "Success": "Успешность",
	// "Profile": "Профиль",
	// "Nickname": "Никнейм",
	// "for payments": "для выплат",
	// "Telephone": "Телефон",
	// "Date of Birth": "Дата рождения",
	// "Tongue": "Язык",
	// "About myself": "О себе",
	// "Change photo": "Изменить фото",
	// "Delete photo": "Удалить фото",
	// "old password": " Старый пароль",
	// "Add to": " Добавить",
	// "Confirm deletion": "Подтвердите удаление",
	// "Are you going to delete": "Вы собираетесь удалить",
	// "Create registration link": "Создание ссылки для регистрации",
	// "Create a": "Создать",
	// "Link to registration form": "Ссылка на форму регистрации",
	// "Floor": "Пол",
	// "Technical": "Технический  ",
	// "A country": "Страна  ",
	// "Change manager request": "Запрос на смену менджера",
	// "New manager": "Новый менеджер",
	// "Confirm": "Подтвердить",
	// "Reject": "Отклонить",
	// "Client editing": "Редактирование клиента",
	// "Surname": "Фамилия",
	// "New password": "Новый пароль",
	// "Save": "Сохранить",
	// "Cancel": "Отменить",
	// "Change the type of work": "Изменить тип работы",
	// "Add work type": "Добавить тип работы",
	// "Successfully remotely": "Успешно удаленно",
	// "Successfully changed": "Успешно измененно",
	// "Total number of tickets": "Общее количество тикетов",
	// "Active tickets": "Активный тикетов",
	// "Income": "Доход",
	// "Money transferred": "Переведено денег",
	// "Total number of orders": "Общее количество заказов",
	// "Active orders": "Активных заказов",
	// "Additional": "Дополнительный ",
	// "Edit": "Редактировать ",
	// "A request has been sent to change the manager": "Отправлен запрос на смену менеджера ",
	// "Search by name.": "Поиск по имени.",
	// "Add case.": "Добавить дело.",
	// "Description": "Описание",
	// "Performed": "Выполнено",
	// "Added successfully": "Успешно добавленно",
	// "Money": "Деньги",
	// "Editing a manager": "Редактирование менеджера",
	// "Email for payments": " Email для выплат",
	// "Order successfully created": "Заказ успешно создан",
	// "Is being discussed": "Обсуждается",
	// "date of creation": "Дата создания",
	// "Name": "Название",
	// "Author": "Автор",
	// "Region": "Область",
	// "Level": "Уровень",
	// "Deadline": "Дедлайн",
	// "Pages": "Страниц",
	// "nature": "природе",
	// "Waiting for a response": "Ожидает ответа",
	// "Answer received": "Ответ получен",
	// "Appeal status": "Статус обращения",
	// "Write a message": "Написать",
	// "Closed": "Закрыто",
	// "Close appeal": "Закрыть обращение",
	// "Open a new ticket": "Открыть новое обращение",
	// "Message text": "Текст обращения",
	// "Send message": "Отправить",
	// "Message subject": "Тема сообщения",
	// "Upload a photo ": "Загрузить фото",
	// "Total works": "Всего работ",
	// "Current works": "Текущих работ",
	// "Favorites": "Избранные",
	// "Refuse to work": "Отказаться от работы",
	// "The client is not responding": "Клиент не отвечает",
	// "Technical support": "Техподдержка",
	// "Data saved": "Данные сохранены",
	// "room": "Номер",
	// "Subject of the appeal": "Тема обращения",
	// "Last Reply": "Последний ответ",
	// "Contractor applications": "Заявки исполнителей",
	// "CTo invite": "Пригласить",
	// "Select": "Выбрать",
	// "Payment details": "Детали оплаты",
	// "Approve": "Утвердить",
	// "Submit for approval": "Отправить на утверждение",
	// "Failed": "Провалено",
	// "You are about to complete the order": "Вы собираетесь завершить заказ",
	// "This action is irreversible": "Данное действие необратимое",
	// "Selected author to order": "Выбран автор на заказ",
	// "Data has been sent for approval": "Данные отправленны на утверждение",
	// "Data sent for client approval": "Данные отправленные на утверждение клиенту",
	// "Thank you, we have received your application": "Спасибо, мы получили вашу заявку",
	// "You are about to refuse an order": "Вы собираетесь отказаться от заказ",
	// "English": "Английский",
	// "Diploma": "Диплом",
	// "Natural Sciences": "Естественные науки",
	// "Client Email": "Email Клиента",
	// "Newton's law": "Закон Ньютона",
	// "Create order": "Создание заказа",
	// "Add stage": "Добавить этап",
	// "Invitations sent": "Приглашения отправленны",
	// "Add a ticket": "Добавить тикет",
	// "Search by name and client": "Поиск по названию и клиенту",
	// "Case review": "Просмотр дела",
	// "Confirmed": "Подтверждается",
	// "In processing": "В обработке",
	// "Awaiting payment": "Ожидает оплаты",
	// "Searching for an artist": "В поиске исполнителя",
	// "In the process": "В процессе",
	// "Completed": "Выполненный",
	// "Not executed with payment": "Не выполнен c выплатой",
	// "Pending consideration": "Ожидает рассмотрения",
	// "Paid out": "Выплачено",
	// "Rejected": "Отклонено",
	// "Reject payment": "Отклонить платеж",
	// "Reason for declining payment": "Причина отклонения платежа",
	// "Current balance": "Текущий баланс",
	// "Withdraw": "Вывести",
	// "Pay out": "Выплатить",
	// "the amount you host withdraw": "сумму Вы хостите вывести",
	// "Transaction ID": "ID транзакция",
	// "Payment system": "Платежная система ",
	// "Payment requests": "Запросы на выплату",
	// "History for payments": "История для выплат",
	// "Declined payments": "Отклоненные выплаты",
};
